export default __webpack_public_path__ + "static/media/the-tech-blog.b297ee91.png";